// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"MultiCamPaywall_ctaButton__V1NqM","ctaWavetrakLink":"MultiCamPaywall_ctaWavetrakLink__eEPr4"};